
import { defineComponent, PropType, reactive } from 'vue'

// Components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Types
import { TTNType } from '@/core/types/transit.types'

// Composable
import useNotifications from '@/common/composable/useNotifications'

// Realisations
import { TRANSIT } from '@/core/realisations/transit.realisation'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<TTNType>,
            required: true,
        },
    },
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_delivered: false,
            is_loading: false,
            is_failed: false,
        })

        const onClick = async () => {
            const answer = confirm(
                `Вы действительно приехали в регион ${props.item.receiver_city}?`
            )
            if (!answer) return

            try {
                state.is_loading = true

                await TRANSIT.setDeliveryDate(props.item.trip_number, props.item.receiver_city)

                state.is_failed = false
                state.is_delivered = true
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При выполнении запроса произошла ошибка',
                })

                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        return { state, onClick }
    },
})
